import { UrlPaths } from "../../config/const";

import { EnvironmentSettings } from "../types/environmentSettings";

export function joinUrl(...segments: string[]): string {
	return segments.map(trimSlashes).join("/");
}

function trimSlashes(value: string): string {
	let result = value;
	while (result.startsWith("/")) {
		result = result.slice(1);
	}
	while (result.endsWith("/")) {
		result = result.slice(0, -1);
	}
	return result;
}

export function createInternalApplicationUrl(
	key: string,
	environment: EnvironmentSettings,
	type: "preview" | "publish"
): string | undefined {
	const baseUrl = environment[`${type}Url`];
	return baseUrl !== undefined ? joinUrl(baseUrl, UrlPaths.portal.internalApplication.subpath, key) : undefined;
}
